import { observer } from 'mobx-react-lite';
import '../../../core/enums/GameSpecificTypes.js';
import '../../../core/enums/MaxPayoutDataTypes.js';
import '../../../core/enums/Chat.js';
import '../../../core/enums/GameModes.js';
import '../../../core/enums/IconTypes.js';
import '../../../core/enums/BetStatus.js';
import '../../../core/enums/PopupTypes.js';
import '../../../core/enums/ApiVersion.js';
import '../../../core/enums/RoundStatus.js';
import '../../../core/enums/FreeBetsStatus.js';
import '../../../core/enums/SocketEvents.js';
import { TranslationKeys } from '../../../core/enums/TranslationKeys.js';
import '../../../core/enums/TimeoutMaxValue.js';
import '../../../core/enums/ApiServiceTypes.js';
import '../../../core/enums/EnvironmentTypes.js';
import '../../../core/enums/DefaultQueryValues.js';
import '../../../core/enums/FreeBetWinningType.js';
import '../../../core/enums/DefaultQueryParams.js';
import '../../../core/enums/BetHistoryFilterTypes.js';
import '../../../core/enums/GameThemeTypes.js';
import '../../../core/enums/RequestStatus.js';
import '../../../core/enums/FetchDefaultPaths.js';
import '../../../core/enums/ResponseCodes.js';
import '../../../../_tslib-7a01aab4.js';
import { a2 as betDataStore } from '../../../../validateBalanceOnBet-af4f4a9b.js';
import '../../../core/store/chatStore.js';
import '../../../core/store/wageringStore.js';
import '../../../core/store/roundInfoStore.js';
import '../../../core/store/userCountStore.js';
import '../../../core/store/gameResultStore.js';
import '../../../core/store/resultHashStore.js';
import '../../../core/store/userWinBetsStore.js';
import '../../../core/store/notificationStore.js';
import '../../../core/store/selectedResultInfoStore.js';
import '../../../core/store/forCrashGame/inputValidationStore.js';
import '../../../core/store/forCrashGame/totalBetStore.js';
import '../../../core/store/forCrashGame/resultReportStore.js';
import '../../../core/store/forCrashGame/gameStore.js';
import '../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../core/services/sound/types.js';
import '../../../core/services/sound/SoundService.js';
import '../../../core/services/sound/defaultSounds.js';
import '../../../core/services/api/types.js';
import '../../../core/services/ApiServices.js';
import '../../../../momentFormat-e9197995.js';
import '../../../core/polyfill.js';
import React from 'react';
import '../../../contexts/TranslationContext.js';
import '../../../contexts/StoreContext.js';
import { useTranslation } from '../../../hooks/useTranslation.js';
import '../../../core/enums/additionalInputValueChangingButtons.js';
import 'mobx';
import '../../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../core/enums/BogLineGameConfig.js';
import '../../../core/helpers/parseQuery.js';
import '../../../core/enums/StatisticsSortingTypes.js';
import '../../../core/services/api/BaseApiService.js';
import '../../../core/helpers/deepCopy.js';
import '../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../core/helpers/formatDate.js';
import '../../../core/helpers/isMobile.js';
import '../../../core/enums/bogGameNames.js';
import '../../../core/helpers/updateHalfBets.js';
import 'howler';
import '../../../../_commonjsHelpers-17aad09c.js';
import '../../../core/helpers/setTranslationValues.js';

var AutoBet = observer(function (_a) {
    var sectionIndex = _a.sectionIndex;
    var t = useTranslation();
    var setIsAutoBetOpen = betDataStore.setIsAutoBetOpen, betsSectionsData = betDataStore.betsSectionsData, resetAutoBet = betDataStore.resetAutoBet;
    var _b = betsSectionsData[sectionIndex], isAutoBet = _b.isAutoBet, autoBetCount = _b.autoBetCount;
    var Stop = TranslationKeys.Stop, AutoBet = TranslationKeys.AutoBet;
    var handleAutoBetOpenClose = function (sectionIndex) {
        if (isAutoBet) {
            resetAutoBet(sectionIndex);
        }
        else {
            setIsAutoBetOpen(true, sectionIndex);
        }
    };
    return (React.createElement("div", { className: "aviabet-autobet-block  ".concat(isAutoBet ? 'type2' : 'type1'), onClick: function () { return handleAutoBetOpenClose(sectionIndex); } },
        React.createElement("p", { className: 'aviabet-autobet-txt' }, isAutoBet ? t(Stop) : t(AutoBet)),
        React.createElement("div", { className: 'aviabet-autobet-icon' }, isAutoBet ? "(".concat(autoBetCount, ")") : React.createElement("i", { className: 'ui-lib-avi-autorenew' }))));
});

export { AutoBet };
